/**
 * 灵感广场 - 用户端开放接口
 * 基础路径：/inspiration
 */
import { get } from '@/utils/request'

/** 获取二级分类列表 */
export function getInspirationCategoryList() {
  return get('/inspiration/category/list')
}

/** 分页查询素材列表 */
export function getInspirationList(params = {}) {
  return get('/inspiration/list', params)
}

/** 查询素材详情 */
export function getInspirationDetail(params = {}) {
  return get('/inspiration/detail', params)
}
